import Bullet from "./Bullet";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrow-left.svg";
import styled, { css } from "styled-components";

const BulletButton: any = styled.button`
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  :hover {
    ${Bullet} {
      background: red;
    }
  }

  ${(p: any) =>
    p.active &&
    css`
      ${Bullet} {
        background: red;
      };
      :hover {
        ${Bullet} {
          background: #ccc;
        }
      };
    `}
`;

export default BulletButton;
